/** Product session category (distinct from per-turn agent `mode` and planning-session todo rows). */
export type SessionKind = 'regular' | 'planning' | 'planned';

export const SESSION_KINDS: readonly SessionKind[] = ['regular', 'planning', 'planned'] as const;

const SESSION_KIND_SET = new Set<string>(SESSION_KINDS);

export function parseSessionKind(raw: unknown): SessionKind {
  if (raw === 'todo') return 'planned';
  if (typeof raw === 'string' && SESSION_KIND_SET.has(raw)) return raw as SessionKind;
  return 'regular';
}

export function isPlanningSessionKind(kind: SessionKind | null | undefined): boolean {
  return kind === 'planning';
}

export function isPlannedSessionKind(kind: SessionKind | null | undefined): boolean {
  return kind === 'planned';
}

/** @deprecated Use isPlannedSessionKind */
export const isTodoSessionKind = isPlannedSessionKind;
